import {
  DialogContent,
  Button,
  Dialog,
  DialogActions,
  Typography,
} from "@mui/material";
import React from "react";
import { makeStyles } from "@material-ui/core";
import palette from "../../theme/palette";
import typography, { pxToRem } from "../../theme/typography";
import NewButton from "../../components/NewButton";
import useWidth from "../../utils/useWidth";
import CommonTypo from "../../components/CommonTypo";

interface IQuesclosePopup {
  open: boolean;
  setopenQuesclosePopup: any;
  setTransformToInfluenceTracking?: any;
  setAddOutcomeTracking?: any;
  setShowOutcome?: any;
  outcomeValueInput?: any;
  SelectRow?: any;
  handleCloseStartModal?: any;
  isDelete?: boolean;
  setBackbuttonPress?: any;
}

const useStyles = makeStyles((theme) => ({
  categoryDialog: {
    "& .MuiDialog-container": {
      "& .MuiPaper-root": {
        borderRadius: "24px",
        padding: "0",
        display: "flex",
        // width: '400px',
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",

        "& .MuiDialogContent-root": {
          padding: "0",
          overflowY: "unset",
        },

        "&. MuiDialogActions-root": {},
        "@media  (max-width: 5000px) and (min-width: 100px)": {
          margin: '0px 0px',
          overflow: 'hidden'
        },
      },
    },
  },
  categoryDialogAction: {
    display: "flex !important",
    alignItems: "center !important",
    justifyContent: "center !important",
    gap: "12px",
    alignSelf: "stretch !important",
    padding: "32px !important",
    borderTop: `1px solid #F3F3F3`,
    "@media  (max-width: 5000px) and (min-width: 100px)": {
      borderTop: `none`,
      flexDirection: "column",
      padding: "0px !important"
    },
  },
  paddingClassMobile: {
    padding: "32px 32px 0px 32px !important",
    "@media  (max-width: 5000px) and (min-width: 100px)": {
      padding: "0px !important",
    },
  },
}));
const QuesclosePopup = (props: IQuesclosePopup) => {
  const classes = useStyles();
  const width = useWidth()
  const isMobile = width < 768
  return (
    <Dialog
      open={props.open}
      onClose={() => props?.setopenQuesclosePopup(false)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      className={`${classes.categoryDialog} dialogWrapper-mobileScreen`}
      sx={
        {
          "& .MuiPaper-root": {
            padding: "0px !important",
            borderRadius: "12px",
            gap: "24px",
            background: "#FFF",
            "@media  (max-width: 5000px)": {
              padding: "32px 24px !important",
              gap: "16px",
              borderRadius: !isMobile ? "12px !important" :"12px 12px 0px 0px !important",
              display: "flex",
              flexDirection: "column",
              height: "max-content",
              maxHeight: "calc(100vh - 5%)",
              width: !isMobile ? "360px" : "100%",
            },
            // position: 'relative'
          },
        }
      }
    >
      <DialogContent id="alert-dialog-description">
        <div
          style={{
            display: "flex",
            padding: isMobile ? "0px !important" : "0px",
            flexDirection: "column",
            alignItems: "flex-start",
            gap: "16px",
            alignSelf: "stretch",
          }}
          className={classes.paddingClassMobile}
        >
          {true ? <CommonTypo size={24} fontWeight={700} color="var(--color-text-primary)" lineHeight={28.8}>
            {props?.isDelete
              ? "You sure you want to clear the entry?"
              : "Are you sure you want to close the window? You will lose unsaved data"}</CommonTypo> : (
            <Typography
              variant="h3"
              component="span"
              lineHeight="135% !important"
              sx={{
                width: "100%",
                textAlign: "center",
                color: palette.common.black,
                fontSize: `${pxToRem(24)} !important`,
                lineHeight: "120% !important",
                fontWeight: `600 !important`,
                fontFamily: `${typography.fontFamily} !important`,
              }}
            >
              {/* Are you sure to transform {props?.outcomeValueInput} to an influence? */}
              {/* Are you sure to recover the history version {props.SelectRow.name}? */}
              Are you sure you want to{" "}
              {props?.isDelete
                ? "delete the entry? You will lose the data"
                : "close the window? You will lose unsaved data"}
            </Typography>
          )}
          {true && props?.isDelete ? <CommonTypo size={16} fontWeight={400} color="var(--color-text-primary)" lineHeight={25.6}>
          {"You can not restore it after this action"}</CommonTypo> : null}
        </div>
      </DialogContent>
      {true ? (
        <DialogActions className={classes.categoryDialogAction}>
          <NewButton
            buttonText={`${props?.isDelete ? "Back" : "No, let me save"}`}
            variant="outlined"
            extraSx={props?.isDelete ? {
              width: "100%",
              background: "var(--color-border)",
              border: `none`,
              height: "40px"
            } : {
              width: "100%",
              background: "var(--color-border)",
              border: `none`,
              height: "40px"
            }}
            typographySx={{
              "&.MuiTypography-root": {
                "@media  (max-width: 726px) and (min-width: 100px)": {
                  fontSize: `${pxToRem(16)} !important`,
                  lineHeight: "100% !important",
                  fontWeight: 600,
                  color: "var(--color-text-primary)"
                },
              },
            }}
            onClick={() => {
              props?.setBackbuttonPress(false);
              props?.setopenQuesclosePopup(false);
            }}
          />
          <NewButton
            buttonText={`${props?.isDelete ? "Clear entry" : "Yes, close"}`}
            variant="contained"
            onClick={props?.handleCloseStartModal}
            extraSx={props?.isDelete ? {
              width: "100%",
              background: "#FF5555",
              border: `none`,
              height: "40px"
            } : {
              width: "100%",
              border: `none`,
              height: "40px"
            }}
            typographySx={{
              "&.MuiTypography-root": {
                "@media  (max-width: 786px) and (min-width: 100px)": {
                  fontSize: `${pxToRem(16)} !important`,
                  lineHeight: "100% !important",
                  fontWeight: 600,
                  color: "var(--color-text-primary)"
                },
              },
            }}
          />
        </DialogActions>
      ) : (
        <DialogActions className={classes.categoryDialogAction}>
          <NewButton
            buttonText="No, let me save"
            variant="contained"
            type="submit"
            onClick={() => {
              props?.setBackbuttonPress && props?.setBackbuttonPress(false);
              props?.setopenQuesclosePopup(false);
            }}
          />
          <NewButton
            buttonText={`Yes, ${props?.isDelete ? "delete" : "close"}`}
            variant="outlined"
            onClick={props?.handleCloseStartModal}
          />
        </DialogActions>
      )}

    </Dialog>
  );
};

export default QuesclosePopup;
